import React, {Component} from 'react';
import {Alert, notification, Button, Icon} from 'antd'


export function infoMsg(inMessage, inDescription) {





    return (



        <div>

          {notification.open({message: inMessage, description: inDescription ,
               icon: <Icon type="info-circle" style={{ color: 'Black' }}/>,
            duration:0})};

        </div>

      );
}
export function warningMsg(inMessage, inDescription) {





          return (



              <div>

                {notification.open({message: inMessage, description: inDescription ,
                     icon: <Icon type="warning" style={{ color: 'Blue' }}/>,
                  duration:0})};

              </div>

            );

}

export function errorMsg(inMessage, inDescription) {





          return (



              <div>

                {notification.open({message: inMessage, description: inDescription ,
                     icon: <Icon type="close-circle" style={{ color: 'Red' }}/>,
                  duration:0})};

              </div>

            );

}
